import { DEFAULT_LOCALE } from '@/shared/config';


export const YEARS_PER_PAGE = 12;

export const MONTHS = {
    [DEFAULT_LOCALE]: {
        full: {
            nominative: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
        },
        short: {
            nominative: [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec',
            ],
        },
    },
};
